export default "__VITE_ASSET__6aa7ed6b__"